module.exports = __webpack_public_path__ + "images/home/fioleMediateurNumerique.0440194f.svg";